<script setup lang="ts">
import type { Cart } from '@shared/shop-api/cart/types'
import EmptyFloatingCart from '@storefront-satch/components/molecules/floating-cart/EmptyFloatingCart.vue'
import FloatingCartLines from '@storefront-satch/components/molecules/floating-cart/FloatingCartLines.vue'

import { CloseCircleIcon } from '@fond-of/satch-icons'

const props = defineProps<{
  cart?: Cart | null
}>()

const emits = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <div
    class="relative h-full w-full cursor-default bg-white px-5 py-6 font-sans text-base text-black shadow-lg lg:w-[29.688rem]"
  >
    <CloseCircleIcon
      class="w-7.5 absolute right-4 top-5 cursor-pointer text-black"
      @click.stop="emits('close')"
    />

    <EmptyFloatingCart v-if="!props.cart?.lines?.length" />

    <FloatingCartLines
      v-if="props.cart?.lines?.length"
      :lines="props.cart.lines"
    />
  </div>
</template>
